import React, { useState, useEffect } from "react";
import { Modal, Button, Icon } from "semantic-ui-react";
import { map, sumBy } from "lodash";
import "./OfferConfirmModal.scss";

export function OfferConfirmModal(props) {
  const { offer, show, onClose, onConfirm } = props;
  const [quantity, setQuantity] = useState(1);

  useEffect(() => {
    if (show) setQuantity(1);
  }, [show, offer]);

  if (!offer) return null;

  const originalTotal = sumBy(offer.products_data, (product) =>
    Number(product.price)
  );
  const savings = originalTotal - Number(offer.price);

  const increment = () => setQuantity((prev) => prev + 1);
  const decrement = () => setQuantity((prev) => Math.max(1, prev - 1));

  const handleConfirm = () => {
    onConfirm({ offer, quantity, items: getOfferItems(offer) });
  };

  const total = (Number(offer.price) * quantity).toFixed(2);

  return (
    <Modal
      className="offer-confirm-modal"
      open={show}
      onClose={onClose}
      size="tiny"
    >
      <Button
        icon
        basic
        labelPosition="left"
        className="offer-confirm-modal__back"
        onClick={onClose}
      >
        <Icon name="arrow left" />
        Regresar al Menu
      </Button>

      <Modal.Content>
        <h3 className="offer-confirm-modal__title">🎁 {offer.title}</h3>

        <div className="offer-confirm-modal__items">
          {map(offer.products_data, (product) => (
            <div className="offer-confirm-modal__item" key={product.id}>
              <span>{product.title}</span>
              <span className="offer-confirm-modal__item-price">
                S/ {product.price}
              </span>
            </div>
          ))}
        </div>

        <div className="offer-confirm-modal__totals">
          <span>Precio normal: S/ {originalTotal.toFixed(2)}</span>
          <span className="offer-confirm-modal__offer-price">
            Precio oferta: S/ {offer.price}
          </span>
          {savings > 0 && (
            <span className="offer-confirm-modal__savings">
              Ahorras S/ {savings.toFixed(2)}
            </span>
          )}
        </div>

        <div className="offer-confirm-modal__section">
          <label>Cantidad</label>
          <div className="offer-confirm-modal__quantity">
            <button type="button" onClick={decrement} disabled={quantity <= 1}>
              −
            </button>
            <span>{quantity}</span>
            <button type="button" onClick={increment}>
              +
            </button>
          </div>
        </div>
      </Modal.Content>

      <Modal.Actions>
        <Button primary fluid onClick={handleConfirm}>
          Agregar al Carrito (S/ {total})
        </Button>
      </Modal.Actions>
    </Modal>
  );
}

export function getOfferItems(offer) {
  const originalTotal = sumBy(offer.products_data, (product) =>
    Number(product.price)
  );

  const items = map(offer.products_data, (product) => ({
    id: product.id,
    title: product.title,
    price:
      originalTotal > 0
        ? Math.round((Number(product.price) / originalTotal) * offer.price * 100) /
          100
        : Number(offer.price) / offer.products_data.length,
  }));

  const allocated = sumBy(items.slice(0, -1), "price");
  items[items.length - 1].price = Number(
    (Number(offer.price) - allocated).toFixed(2)
  );

  return items;
}
